import { PROCESS_STEPS } from "@/lib/data";

export default function Process() {
  return (
    <section id="process" data-testid="process-section" className="py-24 lg:py-32 bg-white">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16">
          <span className="eyebrow">Our Process</span>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl mt-4 text-[#041047] tracking-tight leading-[1.1]">
            A repeatable system for <em className="italic font-medium">predictable growth</em>.
          </h2>
        </div>

        <div className="relative">
          <div className="absolute left-[28px] md:left-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-[#041047]/20 via-[#D4AF37]/40 to-transparent" />
          <div className="flex flex-col gap-14">
            {PROCESS_STEPS.map((step, i) => (
              <div
                key={step.num}
                data-testid={`process-step-${i}`}
                className={`relative flex md:items-center gap-6 md:gap-12 ${
                  i % 2 === 0 ? "md:flex-row" : "md:flex-row-reverse"
                }`}
              >
                <div className="relative z-10 flex-shrink-0 w-14 h-14 md:w-16 md:h-16 bg-[#041047] text-white font-display text-lg flex items-center justify-center md:absolute md:left-1/2 md:-translate-x-1/2">
                  {step.num}
                </div>
                <div className={`flex-1 ${i % 2 === 0 ? "md:text-right md:pr-24" : "md:pl-24"}`}>
                  <h3 className="font-display text-2xl md:text-3xl text-[#041047] mb-2">
                    {step.title}
                  </h3>
                  <p className="text-[#475569] leading-relaxed">{step.desc}</p>
                </div>
                <div className="hidden md:block flex-1" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
